import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://tvsmfaapi.dev-url.com/';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

export const registerUser = createAsyncThunk(
  'mfa/registerUser',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('auth/register', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const enable2FA = createAsyncThunk(
  'mfa/enable2FA',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('2fa/enable-2fa', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const verify2FA = createAsyncThunk(
  'mfa/verify2FA',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('2fa/verify-2fa', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const enableMFA = createAsyncThunk(
  'mfa/enableMFA',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('User_EnableMFA/Enable', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const mfaSlice = createSlice({
  name: 'mfa',
  initialState: {
    mfaEnabled: false,
    loading: false,
    error: null,
  },
  reducers: {
    resetMFA: (state) => {
      state.mfaEnabled = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        toast.success('Registration successful!');
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload?.message || 'Registration failed');
      })
      .addCase(enable2FA.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(enable2FA.fulfilled, (state, action) => {
        state.loading = false;
        toast.success('2FA enabled successfully!');
      })
      .addCase(enable2FA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload?.message || 'Failed to enable 2FA');
      })
      .addCase(verify2FA.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verify2FA.fulfilled, (state, action) => {
        state.loading = false;
        toast.success('MFA verification successful!');
      })
      .addCase(verify2FA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload?.message || 'MFA verification failed');
      })
      .addCase(enableMFA.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(enableMFA.fulfilled, (state, action) => {
        state.loading = false;
        state.mfaEnabled = true;
        toast.success('MFA enabled successfully!');
      })
      .addCase(enableMFA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload?.message || 'Failed to enable MFA');
      });
  },
});

export const { resetMFA } = mfaSlice.actions;
export default mfaSlice.reducer;